<template>
  <div
    class="delivery-address-name"
    @click="isOpened = !isOpened"
    @touchstart.stop
  >
    <ui-input
      :value="disabled ? '' : innerValue"
      ref="input"
      :label="inputLabel"
      :placeholder="isSaveAddress ? 'Например, «Офис»' : 'Выберите адрес'"
      :validate="isSaveAddress ? 'address_name' : ''"
      :disabled="disabled"
      :readonly="!!selectedAddressId || isShowSaveAddress && !isSaveAddress"
      class="delivery-address-name__input"
      @input="$emit('input', $event)"
    >
      <template #append>
        <chevron-animated
          v-if="isAddresses"
          :reverse="isOpened"
          class="delivery-address-name__chevron"
        />
      </template>
    </ui-input>

    <div v-if="isAddresses" class="delivery-address-name__options">
      <ui-dropdown
        :visible="isOpened"
        @on-close="isOpened = false"
      >
        <div
          v-for="option in options"
          :key="option.value"
          class="delivery-address-name__options-item"
          @click="onChange(option)"
        >
          <span>{{ option.name }}</span>
          <f-sprite-icon
            v-if="option.value === selectedAddressId"
            :icon-link="$options.icons.IconCheck.id"
          />
        </div>
      </ui-dropdown>
    </div>
  </div>
</template>

<script>
import ChevronAnimated from '@icons/chevron-animated';

import IconCheck from '@icons/check.svg';

export default {
  name: 'delivery-address-name',

  components: { ChevronAnimated },

  icons: {
    IconCheck,
  },

  props: {
    value: {
      type: String,
      default: '',
    },
    addresses: {
      type: Array,
      default: () => [],
    },
    selectedAddressId: {
      type: String,
      default: '',
    },
    isShowSaveAddress: {
      type: Boolean,
      default: false,
    },
    isSaveAddress: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    isOpened: false,
  }),

  computed: {
    options() {
      const options = this.addresses.map(({ name, id }) => ({ name, value: id }));
      this.selectedAddressId && options.unshift({ name: 'Новый адрес', value: '$new' });
      return options;
    },

    innerValue() {
      return this.selectedAddressId
        ? this.addresses.find(({ id }) => id === this.selectedAddressId)?.name || this.value
        : this.value;
    },

    inputLabel() {
      return `Адрес${this.isSaveAddress ? ' *' : ''}`;
    },

    isAddresses() {
      return !!this.addresses.length;
    },

    disabled() {
      return !this.isAddresses && this.isShowSaveAddress && !this.isSaveAddress;
    },
  },

  watch: {
    isSaveAddress(val, oldVal) { // сброс ошибок валидации если поле не обязательное
      if (val !== oldVal && !val) this.$nextTick(() => this.checkValidOutside());
    },
  },

  methods: {
    checkValidOutside() {
      return this.$refs.input ? this.$refs.input.checkValidOutside() : true;
    },

    onChange({ value } = {}) {
      if (value === '$new') {
        this.$emit('new');
      } else {
        this.$emit('set', value);
        this.$nextTick(() => this.checkValidOutside()); // сброс ошибок валидации с инпута
      }
    },
  },
};
</script>

<style lang="scss">
.delivery-address-name {
  position: relative;
  cursor: pointer;

  &__chevron {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 16px;
    height: 16px;
    color: $gray_lu;
  }

  &__input.ui-input {
    .ui-input-append {
      line-height: 0;
    }

    &.readonly {
      input,
      .ui-input-input {
        background: $white;
        box-shadow: none;
        cursor: pointer;
      }

      .ui-input-append svg {
        color: $gray_lu;
      }
    }
  }

  &__options {
    position: absolute;
    width: 100%;
    top: 72px;

    .ui-dropdown,
    .ui-dropdown-content {
      width: 100%;
    }

    .ui-dropdown-content {
      border-radius: 4px;
    }

    .ui-dropdown-scrollview {
      max-height: 236px;
      padding: 8px 0;
    }
  }

  &__options-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 8px 12px;
    font-size: 14px;
    line-height: 24px;
    background-color: #fff;
    cursor: pointer;
    transition: .2s background-color $gray_bgr;

    &:hover {
      background-color: $gray_bgr;
    }

    & > span {
      width: calc(100% - 16px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .sprite-icon {
      width: 16px;
      height: 16px;
      color: $gray_l;
      transition: .2s opacity ease;
    }
  }

  &_opened {
    .delivery-address-name__input {
      border-color: $black;
    }
  }
}
</style>
